// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectorButton__container-ce69b0 {
  --selector-text-color: var(--base-110);
  --selector-select-icon-color: var(--base-120);
  --selector-label-font: var(--font-caption-2);
  --selector-label-color: var(--base-80);
  --selector-border-radius: 12px;
  --selector-active-border-color: var(--brand-secondary-40);
  display: inline-block;
  height: var(--selector-height);
  min-width: var(--selector-min-width);
  padding: 0 var(--selector-side-offset);
  border-radius: var(--selector-border-radius);
  color: var(--selector-text-color);
  background-color: var(--selector-default-background-color);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.SelectorButton__container-ce69b0:disabled,
.SelectorButton__container-ce69b0:disabled:hover,
.SelectorButton__container-ce69b0:disabled:focus,
.SelectorButton__container-ce69b0:disabled:active {
  background-color: var(--selector-disabled-background-color);
}

.SelectorButton__container-ce69b0:disabled .SelectorButton__content-e5d612 {
  opacity: 0.5;
}

.SelectorButton__container-ce69b0.SelectorButton__active-abac4b {
  background-color: var(--selector-active-background-color);
}

.SelectorButton__container-ce69b0:active {
  background-color: var(--selector-pressed-background-color);
}

.SelectorButton__container-ce69b0:hover,
.SelectorButton__container-ce69b0:focus:hover {
  background-color: var(--selector-hover-background-color);
}

.SelectorButton__container-ce69b0:focus {
  background-color: var(--selector-focused-background-color);
}

.SelectorButton__container-ce69b0::after {
  content: "";
  height: 0;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: var(--selector-active-border-color);
  transition: height 0.2s ease;
}

.SelectorButton__container-ce69b0.SelectorButton__active-abac4b::after {
  height: 2px;
}

.SelectorButton__content-e5d612 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.SelectorButton__icon-bb504e {
  fill: currentColor;
}

.SelectorButton__select-icon-a2544e {
  fill: var(--selector-select-icon-color);
  transition: transform 0.2s ease;
}

.SelectorButton__active-abac4b .SelectorButton__select-icon-a2544e {
  transform: rotateZ(180deg);
}

.SelectorButton__text-d3c8f7,
.SelectorButton__label-e0f779 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.SelectorButton__label-e0f779 {
  font: var(--selector-label-font);
  color: var(--selector-label-color);
}

.SelectorButton__text-content-a3faac {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SelectorButton__text-d3c8f7 {
  display: block;
  font: var(--selector-text-font);
  flex: 1 1;
}

.SelectorButton__theme-standard-c03ae9 {
  --selector-height: 52px;
  --selector-min-width: 126px;
  --selector-side-offset: 12px;
  --selector-text-font: var(--font-body-5);
  --selector-default-background-color: var(--base-20);
  --selector-disabled-background-color: var(--base-0);
  --selector-hover-background-color: var(--base-30);
  --selector-pressed-background-color: var(--base-30);
  --selector-focused-background-color: var(--base-30);
  --selector-active-background-color: var(--base-20);
}

.SelectorButton__theme-without-background-e81306 {
  --selector-height: 40px;
  --selector-min-width: 0px;
  --selector-side-offset: 8px;
  --selector-text-font: var(--font-body-2);
  --selector-default-background-color: transparent;
  --selector-disabled-background-color: transparent;
  --selector-hover-background-color: var(--base-17);
  --selector-pressed-background-color: var(--base-30);
  --selector-focused-background-color: var(--base-17);
  --selector-active-background-color: var(--base-30);
}

.SelectorButton__theme-without-background-secondary-acd3e5 {
  --selector-height: 32px;
  --selector-min-width: 0px;
  --selector-side-offset: 8px;
  --selector-text-font: var(--font-body-2);
  --selector-default-background-color: transparent;
  --selector-disabled-background-color: transparent;
  --selector-hover-background-color: var(--base-30);
  --selector-pressed-background-color: var(--base-40);
  --selector-focused-background-color: var(--base-30);
  --selector-active-background-color: var(--base-40);
}

.SelectorButton__container-ce69b0.SelectorButton__theme-without-background-secondary-acd3e5::after,
.SelectorButton__container-ce69b0.SelectorButton__theme-without-background-secondary-acd3e5.SelectorButton__active-abac4b::after {
  display: none;
  content: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/SelectorButton/SelectorButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,6CAAA;EACA,4CAAA;EACA,sCAAA;EACA,8BAAA;EAEA,yDAAA;EAEA,qBAAA;EAEA,8BAAA;EACA,oCAAA;EACA,sCAAA;EACA,4CAAA;EACA,iCAAA;EACA,0DAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAFF;;AAKA;;;;EAIE,2DAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,yDAAA;AAFF;;AAKA;EACE,0DAAA;AAFF;;AAKA;;EAEE,wDAAA;AAFF;;AAKA;EACE,0DAAA;AAFF;;AAKA;EACE,WAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,qDAAA;EACA,4BAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,uCAAA;EACA,+BAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,kCAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,cAAA;EACA,+BAAA;EACA,SAAA;AAFF;;AAKA;EACE,uBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,wCAAA;EAEA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,mDAAA;EACA,mDAAA;EACA,kDAAA;AAJF;;AAOA;EACE,uBAAA;EACA,yBAAA;EACA,2BAAA;EAEA,wCAAA;EAEA,gDAAA;EACA,iDAAA;EACA,iDAAA;EACA,mDAAA;EACA,mDAAA;EACA,kDAAA;AANF;;AASA;EACE,uBAAA;EACA,yBAAA;EACA,2BAAA;EAEA,wCAAA;EAEA,gDAAA;EACA,iDAAA;EACA,iDAAA;EACA,mDAAA;EACA,mDAAA;EACA,kDAAA;AARF;;AAWA;;EAEE,aAAA;EACA,aAAA;AARF","sourcesContent":[".container {\n  --selector-text-color: var(--base-110);\n  --selector-select-icon-color: var(--base-120);\n  --selector-label-font: var(--font-caption-2);\n  --selector-label-color: var(--base-80);\n  --selector-border-radius: 12px;\n\n  --selector-active-border-color: var(--brand-secondary-40);\n\n  display: inline-block;\n\n  height: var(--selector-height);\n  min-width: var(--selector-min-width);\n  padding: 0 var(--selector-side-offset);\n  border-radius: var(--selector-border-radius);\n  color: var(--selector-text-color);\n  background-color: var(--selector-default-background-color);\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.container:disabled,\n.container:disabled:hover,\n.container:disabled:focus,\n.container:disabled:active {\n  background-color: var(--selector-disabled-background-color);\n}\n\n.container:disabled .content {\n  opacity: 0.5;\n}\n\n.container.active {\n  background-color: var(--selector-active-background-color);\n}\n\n.container:active {\n  background-color: var(--selector-pressed-background-color);\n}\n\n.container:hover,\n.container:focus:hover {\n  background-color: var(--selector-hover-background-color);\n}\n\n.container:focus {\n  background-color: var(--selector-focused-background-color);\n}\n\n.container::after {\n  content: '';\n  height: 0;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: var(--selector-active-border-color);\n  transition: height 0.2s ease;\n}\n\n.container.active::after {\n  height: 2px;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\n.icon {\n  fill: currentColor;\n}\n\n.select-icon {\n  fill: var(--selector-select-icon-color);\n  transition: transform 0.2s ease;\n}\n\n.active .select-icon {\n  transform: rotateZ(180deg);\n}\n\n.text,\n.label {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.label {\n  font: var(--selector-label-font);\n  color: var(--selector-label-color);\n}\n\n.text-content {\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text {\n  display: block;\n  font: var(--selector-text-font);\n  flex: 1 1;\n}\n\n.theme-standard {\n  --selector-height: 52px;\n  --selector-min-width: 126px;\n  --selector-side-offset: 12px;\n\n  --selector-text-font: var(--font-body-5);\n\n  --selector-default-background-color: var(--base-20);\n  --selector-disabled-background-color: var(--base-0);\n  --selector-hover-background-color: var(--base-30);\n  --selector-pressed-background-color: var(--base-30);\n  --selector-focused-background-color: var(--base-30);\n  --selector-active-background-color: var(--base-20);\n}\n\n.theme-without-background {\n  --selector-height: 40px;\n  --selector-min-width: 0px;\n  --selector-side-offset: 8px;\n\n  --selector-text-font: var(--font-body-2);\n\n  --selector-default-background-color: transparent;\n  --selector-disabled-background-color: transparent;\n  --selector-hover-background-color: var(--base-17);\n  --selector-pressed-background-color: var(--base-30);\n  --selector-focused-background-color: var(--base-17);\n  --selector-active-background-color: var(--base-30);\n}\n\n.theme-without-background-secondary {\n  --selector-height: 32px;\n  --selector-min-width: 0px;\n  --selector-side-offset: 8px;\n\n  --selector-text-font: var(--font-body-2);\n\n  --selector-default-background-color: transparent;\n  --selector-disabled-background-color: transparent;\n  --selector-hover-background-color: var(--base-30);\n  --selector-pressed-background-color: var(--base-40);\n  --selector-focused-background-color: var(--base-30);\n  --selector-active-background-color: var(--base-40);\n}\n\n.container.theme-without-background-secondary::after,\n.container.theme-without-background-secondary.active::after {\n  display: none;\n  content: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectorButton__container-ce69b0`,
	"content": `SelectorButton__content-e5d612`,
	"active": `SelectorButton__active-abac4b`,
	"icon": `SelectorButton__icon-bb504e`,
	"select-icon": `SelectorButton__select-icon-a2544e`,
	"selectIcon": `SelectorButton__select-icon-a2544e`,
	"text": `SelectorButton__text-d3c8f7`,
	"label": `SelectorButton__label-e0f779`,
	"text-content": `SelectorButton__text-content-a3faac`,
	"textContent": `SelectorButton__text-content-a3faac`,
	"theme-standard": `SelectorButton__theme-standard-c03ae9`,
	"themeStandard": `SelectorButton__theme-standard-c03ae9`,
	"theme-without-background": `SelectorButton__theme-without-background-e81306`,
	"themeWithoutBackground": `SelectorButton__theme-without-background-e81306`,
	"theme-without-background-secondary": `SelectorButton__theme-without-background-secondary-acd3e5`,
	"themeWithoutBackgroundSecondary": `SelectorButton__theme-without-background-secondary-acd3e5`
};
module.exports = ___CSS_LOADER_EXPORT___;
